// Musique du bandit manchot (services/audio.js#setMusicScene) : une petite boucle de flipper, à la place de la boucle du
// labyrinthe tant que le bandit est affiché. Un arpège carré rapide, en doubles croches, qui rebondit sur les notes de
// l'accord, et une basse en triangle sur les temps ; quatre mesures do – la mineur – fa – sol, puis on recommence.
// Le tempo est celui du jeu (Transport de Tone.js) ; tout passe par `destination`, le nœud de volume du jeu. C'est de la
// musique : le bouton musique la coupe, comme la boucle du labyrinthe.

// Une mesure par accord : 16 doubles croches. Arpège : monte, redescend, rebondit (null = silence) ; basse : fondamentale
// sur les temps 1 et 3, quinte sur les temps 2 et 4.
const BARS = [
  { lead: ['C5', 'E5', 'G5', 'C6', 'G5', 'E5', 'G5', 'C6', 'E6', null, 'C6', 'G5', 'E5', 'G5', 'C6', null], bass: ['C3', 'G2'] },
  { lead: ['A4', 'C5', 'E5', 'A5', 'E5', 'C5', 'E5', 'A5', 'C6', null, 'A5', 'E5', 'C5', 'E5', 'A5', null], bass: ['A2', 'E2'] },
  { lead: ['F4', 'A4', 'C5', 'F5', 'C5', 'A4', 'C5', 'F5', 'A5', null, 'F5', 'C5', 'A4', 'C5', 'F5', null], bass: ['F2', 'C3'] },
  { lead: ['G4', 'B4', 'D5', 'G5', 'D5', 'B4', 'D5', 'G5', 'B5', 'D6', 'B5', 'G5', 'F5', 'D5', 'B4', 'D5'], bass: ['G2', 'D3'] },
];

/** Les 64 doubles croches de la boucle : { lead, bass } (null = rien sur ce pas). Fonction pure, pour les tests. */
export const PINBALL_STEPS = Object.freeze(BARS.flatMap(({ lead, bass }) => lead.map((note, i) => ({
  lead: note,
  bass: i % 4 === 0 ? bass[(i / 4) % 2] : null,
}))));

/**
 * @param {typeof import('tone')} Tone
 * @param {import('tone').ToneAudioNode} destination
 */
export function createSlotMusic(Tone, destination) {
  const lead = new Tone.Synth({
    oscillator: { type: 'square' },
    envelope: { attack: 0.002, decay: 0.09, sustain: 0.05, release: 0.05 },
  }).connect(destination);
  lead.volume.value = -11; // sous les sons du bandit (levier, rouleaux, cloche) et la boucle du labyrinthe

  const bass = new Tone.Synth({
    oscillator: { type: 'triangle' },
    envelope: { attack: 0.004, decay: 0.2, sustain: 0.2, release: 0.1 },
  }).connect(destination);
  bass.volume.value = -1;

  let step = 0;
  const loop = new Tone.Loop((time) => {
    const { lead: note, bass: low } = PINBALL_STEPS[step];
    if (note) lead.triggerAttackRelease(note, '32n', time, 0.7);
    if (low) bass.triggerAttackRelease(low, '8n', time, 0.9);
    step = (step + 1) % PINBALL_STEPS.length;
  }, '16n');

  return {
    /** Lance la boucle depuis la première mesure ; sans effet si elle joue déjà. */
    start() {
      if (loop.state === 'started') return;
      step = 0;
      loop.start(0);
    },
    stop() {
      if (loop.state === 'started') loop.stop();
    },
    get isPlaying() { return loop.state === 'started'; },
  };
}
